import script from "./ModalEstenderPrazoAvaliacao.vue?vue&type=script&setup=true&lang=js"
export * from "./ModalEstenderPrazoAvaliacao.vue?vue&type=script&setup=true&lang=js"

import "./ModalEstenderPrazoAvaliacao.vue?vue&type=style&index=0&id=90019f48&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-90019f48"]])

export default __exports__